export default "__VITE_ASSET__gMGKi0Rt__"